<!-- TODO: this used to be a SvelteKit +layout.svelte. Migrate any shared markup into App.svelte or a parent component. -->
<script>
  const browser = typeof window !== 'undefined';
  import { onMount } from 'svelte';
  import { shouldAllowAutoSignIn, user, isAuthenticated } from '$stores/sessionStore';

  onMount(async () => {
    if (!browser) return;

    if (!shouldAllowAutoSignIn()) {
      console.log('LOGIN LAYOUT: Auto sign-in blocked due to recent logout');
      return;
    }

    try {
      const res = await fetch('/api/v1/auth/profile', { credentials: 'include' });

      if (res.ok) {
        console.log('LOGIN LAYOUT: Valid server session, redirecting to dashboard');
        window.location.replace('/dashboard');
        return;
      }

      if (res.status === 401 || res.status === 403) {
        console.log('LOGIN LAYOUT: No valid session; clearing stale client auth state if present');
        localStorage.removeItem('user');
        localStorage.removeItem('roles');
        user.set(null);
        isAuthenticated.set(false);
      }
    } catch (err) {
      console.error('LOGIN LAYOUT: Session check failed', err);
    }

    console.log('LOGIN LAYOUT: Staying on login page');
  });
</script>

<slot />
